











import { Vue, Component, Prop } from "vue-property-decorator";
import { Rule } from "../core/messages";
import RuleWrapper from "./RuleWrapper.vue";

@Component({
  components: {
    RuleWrapper
  }
})
export default class RuleBuilder extends Vue {
  // Props
  @Prop({ type: Object })
  value!: Rule;

  // Data
  // Computed
  // Methods
  createRule() {
    const rule: Rule = {
      op: "==",
      field: "roonVersion",
      value: ""
    };
    this.$emit("input", rule);
  }
  // Life-cycle hooks
}
